import { mockData as documentEventsData } from '@web/lib/demo/data/documentEvents';
import { getDocumentUsers } from '@web/lib/demo/procedures/getDocumentUsers';
import { DriveEventActionEnum } from '@workalizer/shared';
var getUserById = function (userId) {
    var users = getDocumentUsers({ documentId: 0 }).users;
    var user = users.find(function (item) { return item.id === userId; });
    if (!user) {
        return null;
    }
    return {
        id: user.id,
        name: user.name,
        email: user.email,
        orgUnitTitle: 'Finance'
    };
};
export var documentItemHeader = function (input) {
    var _a, _b;
    var scopedEvents = documentEventsData
        .filter(function (event) { return event.document.id === input.documentId; })
        .sort(function (a, b) { return new Date(b.date).getTime() - new Date(a.date).getTime(); });
    var document = (_a = scopedEvents[0]) === null || _a === void 0 ? void 0 : _a.document;
    if (!document) {
        return null;
    }
    var latestActivity = scopedEvents.find(function (event) { return event.action !== DriveEventActionEnum.DOCUMENT_VIEW; });
    var latestView = scopedEvents.find(function (event) { return event.action === DriveEventActionEnum.DOCUMENT_VIEW; });
    var createEvent = scopedEvents.find(function (event) { return event.action === DriveEventActionEnum.DOCUMENT_CREATE; });
    var ownerUserId = (_b = scopedEvents[0]) === null || _b === void 0 ? void 0 : _b.userId;
    var owner = ownerUserId ? getUserById(ownerUserId) : null;
    var mapActivity = function (event) {
        var _a, _b;
        var user = getUserById((_a = event === null || event === void 0 ? void 0 : event.userId) !== null && _a !== void 0 ? _a : 0);
        if (!event || !user) {
            return null;
        }
        return {
            date: event.date,
            action: event.action,
            subAction: (_b = event.subAction) !== null && _b !== void 0 ? _b : null,
            user: user
        };
    };
    return {
        id: document.id,
        title: document.title,
        type: document.type,
        slugId: document.slugId,
        owner: owner,
        created: mapActivity(createEvent),
        lastViewed: mapActivity(latestView),
        lastActivity: mapActivity(latestActivity),
        users: getDocumentUsers({ documentId: input.documentId }).users
    };
};
